export const CURRENCY_SYMBOL_LS_TOKEN = 'currencySymbolsMap';

export const EXPIRY_TOKEN = '__expiry';

export enum UKCurrencies {
  EUR = 'Euro',
  GBP = 'Great Britain Pound',
  PoundPerSqFt = '£/SqFt',
  EuroPerSqFt = '€/SqFt',
  PoundPerAcre = '£/Acre',
  EuroPerAcre = '€/Acre',
  PoundPerHectare = '£/Hectare',
  EuroPerHectare = '€/Hectare',
  EuroPerSQM = '€/Sqm',
  PoundPerSQM = '£/Sqm',
  PoundCurrencyCheck = '£',
  EuroCurrencyCheck = '€',
}

export const CurrencyAreaMapping = {
  'Great Britain Pound': {
    'Square Foot': '£/SqFt',
    Hectare: '£/Hectare',
    Acre: '£/Acre',
    'Square Meter': '£/Sqm',
  },
  Euro: {
    'Square Foot': '€/SqFt',
    Hectare: '€/Hectare',
    Acre: '€/Acre',
    'Square Meter': '€/Sqm',
  },
};
